import './ToolbarDriftWarning.scss';

import { IconAlertWarningSolid } from '@hulu-react-style-components/icons';
import React from 'react';

import bem from '../../../../utils/bem';

export interface ToolbarDriftWarningProps {
  onClick?: () => void;
}

const [block, element] = bem('toolbar-drift-warning');

const DRIFT_MESSAGE = 'Filters have been added, removed, or changed and no longer match this saved Custom Filter.';

const ToolbarDriftWarning = ({ onClick }: ToolbarDriftWarningProps): JSX.Element => (
  <button type="button" className={block()} data-testid="toolbar-drift-warning" onClick={onClick}>
    <IconAlertWarningSolid className={element('icon')} width="14px" height="14px" />
    <span>{DRIFT_MESSAGE}</span>
  </button>
);

export default ToolbarDriftWarning;
